import { useEffect, useRef, useState } from "react";
import { Volume2, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { t } from "@/lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let playing = null;

export const stopAllAudio = () => playing?.();

export const toSpeech = (md) =>
  md
    .replace(/^#{1,6}\s*/gm, "")
    .replace(/\*\*|__|\*|_|`/g, "")
    .replace(/^\s*[-*]\s*\[[ x]?\]\s*/gim, "")
    .replace(/^\s*[-•]\s+/gm, "")
    .replace(/\[(.+?)\]\((.+?)\)/g, "$1")
    .replace(/https?:\/\/\S+/g, "")
    .replace(/\n{2,}/g, "\n")
    .trim()
    .slice(0, 4000);

export const ListenButton = ({ text, index }) => {
  const [state, setState] = useState("idle");
  const audio = useRef(null);
  const url = useRef(null);

  useEffect(() => () => {
    audio.current?.pause();
    if (url.current) URL.revokeObjectURL(url.current);
  }, []);

  const stop = () => {
    audio.current?.pause();
    if (audio.current) audio.current.currentTime = 0;
    setState("idle");
  };

  const play = async () => {
    if (playing && playing !== stop) playing();
    playing = stop;
    try {
      if (!url.current) {
        setState("loading");
        const res = await fetch(`${API}/tts`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ text: toSpeech(text) }) });
        if (!res.ok) throw new Error();
        url.current = URL.createObjectURL(await res.blob());
        audio.current = new Audio(url.current);
        audio.current.onended = () => setState("idle");
        if (playing !== stop) return setState("idle");
      }
      await audio.current.play();
      setState("playing");
    } catch {
      setState("idle");
      toast.error(t("tts.err"));
    }
  };

  const active = state === "playing";
  return (
    <button
      data-testid={`listen-button-${index}`}
      data-state={state}
      onClick={active ? stop : play}
      disabled={state === "loading"}
      className={`flex items-center gap-2 rounded-full border px-3 py-2 text-xs font-semibold transition-colors ${
        active ? "border-ac-strong bg-ac-strong text-white" : "border-ac-line bg-ac-surface text-ac-ink hover:bg-ac-surface2"
      }`}
    >
      {state === "loading" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : active ? <Square className="h-3 w-3 fill-current" /> : <Volume2 className="h-3.5 w-3.5" />}
      {active ? t("msg.stop") : t("msg.listen")}
      {active && (
        <span className="flex items-end gap-0.5">
          <i className="hg-eq" /><i className="hg-eq" style={{ animationDelay: "150ms" }} /><i className="hg-eq" style={{ animationDelay: "300ms" }} />
        </span>
      )}
    </button>
  );
};
